import React from 'react';

const Report = () => (
  <iframe title="REPORT" width="100%" height="100%" src={`${process.env.REACT_APP_DATA_STUDIO_URL}`} />
);

export default Report;
